// import React, { useState } from "react";
// import { Switch } from "@headlessui/react";
// import { Calendar, Repeat, FileText } from "lucide-react";
// import { useAppDispatch } from "../../../redux/store";
// import { createUnavailability } from "../../../redux/features/unavailability/api";

// const days = ["S", "M", "T", "W", "T", "F", "S"];
// const fullDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// export default function UnavailabilityFormComponent() {
//   const [startDate, setStartDate] = useState<string>();
//   const dispatch = useAppDispatch();
//   const [fromTime, setFromTime] = useState<string | undefined>(undefined);
//   const [toTime, setToTime] = useState<string | undefined>(undefined);
//   const [endDate, setEndDate] = useState<string | undefined>(undefined);
//   const [allDay, setAllDay] = useState<boolean>(false);
//   const [repeating, setRepeating] = useState<boolean>(false);
//   const [repeatDays, setRepeatDays] = useState<number[]>([2]); // Tuesday selected by default
//   const [note, setNote] = useState("");

//   const toggleDay = (index: number) => {
//     setRepeatDays((prev) =>
//       prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
//     );
//   };
//   const getSelectedDaysForApi = (): string => {
//     return repeatDays.map((i) => fullDays[i]).join(",");
//   };

//   const Line = () => <hr className="border-gray-200" />;

//   const handleSubmit = () => {
//     const payload = {
//       start_date: startDate,
//       from_time: fromTime,
//       to_time: toTime,
//       end_date: endDate,
//       all_day: allDay ? 1 as 1 : 0 as 0,
//       repeating: repeating ? 1 as 1 : 0 as 0,
//       repeat_days: getSelectedDaysForApi(),
//       note,
//       overwrite_existing_slots: 1 as 1, // add default or pass dynamically
//     };
//     console.log("Payload to send:", payload);
//     dispatch(createUnavailability(payload))
//       .unwrap()
//       .then((response) => {
//         alert(response.message || "Unavailability created successfully!");
//         // Optionally reset form or navigate
//       })
//       .catch((error) => {
//         alert("Failed to create unavailability slot.");
//         console.error(error);
//       });
//   };

//   return (
//     <div className="p-4 space-y-0 bg-white rounded-lg shadow-md max-w-md mx-auto">
//       {/* Date */}
//       <div className="flex justify-between items-center py-3">
//         <div className="flex items-center gap-2">
//           <Calendar className="text-blue-600" />
//           <span className="font-medium text-blue-600">Date</span>
//         </div>
//         <input
//           type="date"
//           value={startDate}
//           onChange={(e) => setStartDate(e.target.value)}
//           className="mt-1 w-[3/4] rounded-md border border-blue-500 p-1 text-xs text-gray-800 focus:border-blue-500 focus:ring focus:ring-blue-200"
//         />
//       </div>
//       <Line />

//       {/* All Day */}
//       <div className="flex justify-between items-center py-3 text-blue-600">
//         <span>All Day</span>
//         <Switch
//           checked={allDay}
//           onChange={setAllDay}
//           className={`${
//             allDay ? "bg-blue-600" : "bg-gray-300"
//           } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
//         >
//           <span
//             className={`inline-block h-4 w-4 transform bg-white rounded-full transition ${
//               allDay ? "translate-x-5" : "translate-x-1"
//             }`}
//           />
//         </Switch>
//       </div>
//       <Line />

//       {/* From */}
//       {!allDay && (
//         <>
//           <div className="flex justify-between items-center py-3 ">
//             <span className="text-blue-600">From</span>
//             <input
//               type="time"
//               value={fromTime}
//               onChange={(e) => setFromTime(e.target.value + ":00")} // add seconds HH:mm:ss
//               className="mt-1 w-[3/4] rounded-md border border-blue-500 p-1 text-xs text-gray-800 focus:border-blue-500 focus:ring focus:ring-blue-200"
//             />
//           </div>
//           <Line />

//           {/* To */}
//           <div className="flex justify-between items-center py-3">
//             <span className="text-blue-600">To</span>
//             <input
//               type="time"
//               value={toTime}
//               onChange={(e) => setToTime(e.target.value + ":00")}
//               className="mt-1 w-[3/4] rounded-md border border-blue-500 p-1 text-xs text-gray-800 focus:border-blue-500 focus:ring focus:ring-blue-200"
//             />
//           </div>
//           <Line />
//         </>
//       )}

//       {/* Repeating Slot */}
//       <div className="flex justify-between items-center py-3">
//         <div className="flex items-center gap-2">
//           <Repeat className="text-blue-600" />
//           <span className="font-medium text-blue-600">Repeating Slot</span>
//         </div>
//         <Switch
//           checked={repeating}
//           onChange={setRepeating}
//           className={`${
//             repeating ? "bg-blue-600" : "bg-gray-300"
//           } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
//         >
//           <span
//             className={`inline-block h-4 w-4 transform bg-white rounded-full transition ${
//               repeating ? "translate-x-5" : "translate-x-1"
//             }`}
//           />
//         </Switch>
//       </div>
//       <Line />

//       {/* Repeats */}
//       {repeating && (
//         <>
//           <div className="py-3">
//             <label className="font-medium block mb-2 text-blue-600">
//               Repeats
//             </label>
//             <div className="flex space-x-2 mb-1">
//               {days.map((d, i) => (
//                 <button
//                   key={i}
//                   onClick={() => toggleDay(i)}
//                   className={`w-8 h-8 rounded-full border ${
//                     repeatDays.includes(i)
//                       ? "bg-blue-600 text-white"
//                       : "bg-white text-gray-800"
//                   }`}
//                 >
//                   {d}
//                 </button>
//               ))}
//             </div>
//             <p className="text-sm text-blue-600">Weekly</p>
//           </div>
//           <Line />

//           {/* Ends On */}
//           <div className="flex justify-between items-center py-3">
//             <div className="flex items-center gap-2">
//               <Calendar className="text-blue-600" />
//               <span className="font-medium text-blue-600">Ends On</span>
//             </div>
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               className="mt-1 w-[3/4] rounded-md border border-blue-500 p-1 text-xs text-gray-800 focus:border-blue-500 focus:ring focus:ring-blue-200"
//             />
//           </div>
//           <Line />
//         </>
//       )}

//       {/* Note */}
//       <div className="py-3">
//         <div className="flex items-center gap-2 mb-1">
//           <FileText className="text-blue-600" />
//           <span className="font-medium text-blue-600">Note</span>
//         </div>
//         <textarea
//           value={note}
//           onChange={(e) => setNote(e.target.value)}
//           className="w-full border border-blue-500 rounded px-2 py-1"
//           rows={3}
//           placeholder="Enter note..."
//         />
//       </div>

//       {/* Submit button example */}
//       <div className="pt-4">
//         <button
//           onClick={handleSubmit}
//           className="w-full rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
//         >
//           Submit
//         </button>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useLayoutEffect } from "react";
import { Switch } from "@headlessui/react";
import { Calendar, Repeat, FileText } from "lucide-react";
import { RootState, useAppDispatch } from "../../../redux/store";
import { createUnavailability } from "../../../redux/features/unavailability/api";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const days = ["S", "M", "T", "W", "T", "F", "S"];
const fullDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function UnavailabilityFormComponent() {
  const [startDate, setStartDate] = useState<string>();
  const dispatch = useAppDispatch();
  const { unAvailability } = useSelector(
    (state: RootState) => state.unavailability
  );
  console.log("unAvailability=============", unAvailability);
  const [fromTime, setFromTime] = useState<string | undefined>(undefined);
  const [toTime, setToTime] = useState<string | undefined>(undefined);
  const [endDate, setEndDate] = useState<string | undefined>(undefined);
  const [allDay, setAllDay] = useState<boolean>(false);
  const [repeating, setRepeating] = useState<boolean>(false);
  const [repeatDays, setRepeatDays] = useState<number[]>([2]); // Tuesday selected by default
  const [overwriteExistingSlots, setOverwriteExistingSlots] =
    useState<boolean>(false);
  const [note, setNote] = useState("");

  // Reset fromTime and toTime if allDay is true
  useEffect(() => {
    if (allDay) {
      setFromTime(undefined);
      setToTime(undefined);
    }
  }, [allDay]);

  const toggleDay = (index: number) => {
    setRepeatDays((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const getSelectedDaysForApi = (): string => {
    return repeatDays.map((i) => fullDays[i]).join(",");
  };

  const Line = () => <hr className="border-gray-200" />;

  const handleSubmit = () => {
    const payload = {
      start_date: startDate,
      from_time: fromTime,
      to_time: toTime,
      end_date: endDate,
      all_day: allDay ? (1 as 1) : (0 as 0),
      repeating: repeating ? (1 as 1) : (0 as 0),
      repeat_days: repeating ? getSelectedDaysForApi() : "", // reset if repeating false
      note,
      overwrite_existing_slots: overwriteExistingSlots ? (1 as 1) : (0 as 0),
    };
    dispatch(createUnavailability(payload))
      .unwrap()
      .then((response) => {
        alert(response.message || "Unavailability created successfully!");
        // Optionally reset form or navigate
      })
      .catch((error) => {
        toast.error(error)
      });
  };

  useLayoutEffect(() => {
    dispatch(setTopNavNameTitle("Unavailability"));
  }, [dispatch]);

  return (
    <div className="p-4 space-y-0 bg-white rounded-lg shadow-md max-w-md mx-auto">
      {/* Date */}
      <div className="flex justify-between items-center py-3">
        <div className="flex items-center gap-2">
          <Calendar className="text-blue-600" />
          <span className="font-medium text-blue-600">Date</span>
        </div>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="mt-1 w-[3/4] rounded-md border border-blue-500 p-1 text-xs text-gray-800 focus:border-blue-500 focus:ring focus:ring-blue-200"
        />
      </div>
      <Line />

      {/* All Day */}
      <div className="flex justify-between items-center py-3 text-blue-600">
        <span>All Day</span>
        <Switch
          checked={allDay}
          onChange={setAllDay}
          className={`${
            allDay ? "bg-blue-600" : "bg-gray-300"
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
        >
          <span
            className={`inline-block h-4 w-4 transform bg-white rounded-full transition ${
              allDay ? "translate-x-5" : "translate-x-1"
            }`}
          />
        </Switch>
      </div>
      <Line />

      {/* From */}
      {!allDay && (
        <>
          <div className="flex justify-between items-center py-3 ">
            <span className="text-blue-600">From</span>
            <input
              type="time"
              value={fromTime}
              onChange={(e) => setFromTime(e.target.value + ":00")} // add seconds HH:mm:ss
              className="mt-1 w-[3/4] rounded-md border border-blue-500 p-1 text-xs text-gray-800 focus:border-blue-500 focus:ring focus:ring-blue-200"
            />
          </div>
          <Line />

          {/* To */}
          <div className="flex justify-between items-center py-3">
            <span className="text-blue-600">To</span>
            <input
              type="time"
              value={toTime}
              onChange={(e) => setToTime(e.target.value + ":00")}
              className="mt-1 w-[3/4] rounded-md border border-blue-500 p-1 text-xs text-gray-800 focus:border-blue-500 focus:ring focus:ring-blue-200"
            />
          </div>
          <Line />
        </>
      )}

      {/* Repeating Slot */}
      <div className="flex justify-between items-center py-3">
        <div className="flex items-center gap-2">
          <Repeat className="text-blue-600" />
          <span className="font-medium text-blue-600">Repeating Slot</span>
        </div>
        <Switch
          checked={repeating}
          onChange={setRepeating}
          className={`${
            repeating ? "bg-blue-600" : "bg-gray-300"
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
        >
          <span
            className={`inline-block h-4 w-4 transform bg-white rounded-full transition ${
              repeating ? "translate-x-5" : "translate-x-1"
            }`}
          />
        </Switch>
      </div>
      <Line />

      {/* Repeats */}
      {repeating && (
        <>
          <div className="py-3">
            <label className="font-medium block mb-2 text-blue-600">
              Repeats
            </label>
            <div className="flex space-x-2 mb-1">
              {days.map((d, i) => (
                <button
                  key={i}
                  onClick={() => toggleDay(i)}
                  className={`w-8 h-8 rounded-full border ${
                    repeatDays.includes(i)
                      ? "bg-blue-600 text-white"
                      : "bg-white text-gray-800"
                  }`}
                >
                  {d}
                </button>
              ))}
            </div>
            <p className="text-sm text-blue-600">Weekly</p>
          </div>
          <Line />
        </>
      )}

      {/* Overwrite Existing Slots */}
      <div className="flex justify-between items-center py-3 text-blue-600">
        <span>Overwrite Existing Slots</span>
        <Switch
          checked={overwriteExistingSlots}
          onChange={setOverwriteExistingSlots}
          className={`${
            overwriteExistingSlots ? "bg-blue-600" : "bg-gray-300"
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
        >
          <span
            className={`inline-block h-4 w-4 transform bg-white rounded-full transition ${
              overwriteExistingSlots ? "translate-x-5" : "translate-x-1"
            }`}
          />
        </Switch>
      </div>
      <Line />

      {/* Ends On */}
      <div className="flex justify-between items-center py-3">
        <div className="flex items-center gap-2">
          <Calendar className="text-blue-600" />
          <span className="font-medium text-blue-600">Ends On</span>
        </div>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="mt-1 w-[3/4] rounded-md border border-blue-500 p-1 text-xs text-gray-800 focus:border-blue-500 focus:ring focus:ring-blue-200"
        />
      </div>
      <Line />

      {/* Note */}
      <div className="py-3">
        <div className="flex items-center gap-2 mb-1">
          <FileText className="text-blue-600" />
          <span className="font-medium text-blue-600">Note</span>
        </div>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="w-full border border-blue-500 rounded px-2 py-1"
          rows={3}
          placeholder="Enter note..."
        />
      </div>

      {/* Submit button */}
      <div className="pt-4">
        <button
          onClick={handleSubmit}
          className="w-full rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
        >
          Submit
        </button>
      </div>
    </div>
  );
}
